import { useEventRefresher, useReadableEventRefresher } from '@zdrbm/zdr-react';
import { IConversationRun } from '../../model/ConversationRun';

export function useConversationRun(run: IConversationRun) {
    const [[input], [status]] = useReadableEventRefresher(run.input, run.status);

    useEventRefresher(run.responseContainers.itemsAdded);
    return { input, status, containers: run.responseContainers.getOrderedItems() };
}
